<template>
  <div class="home">
    <div>
      <p class="title">打印列表</p>
      <div class="actions">
        <el-button v-if="false" class="btn" type="primary" round @click="printAll">一键打印</el-button>
      </div>
    </div>
    <el-table class="el-table" :data="tableData" border height="80vh">
      <el-table-column prop="txt" label="序列号"></el-table-column>
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <el-button type="primary" round @click="readyPrint(scope.row)">打印</el-button>
          <!--                <el-button type="danger" round>删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="打印预览" :visible.sync="dialogVisible" width="600px" @close="closeDialog">
      <div class="scroll">
        <div id="printContent" style="text-align: center;">
          <div class="qrcode-item" >
            <img
              style="width: 200px"
              :src="item.url"
              alt
            />
            <p>{{item.txt}}</p>
          </div>
        </div>
      </div>

      <div style="text-align: center;margin-top: 30px">
        <el-button type="primary" round @click="closeDialog" v-print="'#printContent'">确定</el-button>
        <el-button type="danger" round @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import { Message } from "element-ui";
import { getList, postMd5 } from "../libs/api";
import Vue from "vue";
import Print from "vue-print-nb";
import md5 from "js-md5";
import sha256 from "js-sha256";

Vue.use(Print);

export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      printList: [],
      item:{},
      time:new Date().getTime()
    };
  },
  components: {
    "el-table": Table,
    "el-table-column": TableColumn
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getList()
        .then(res => {
          res.data && res.data.length && this.afresh(res.data);
          let items = [];
          for (let i = 0; i < res.data.length; i++) {
            let fileName =  res.data[i]
            items.push({
              status: 0,
              img: fileName,
              txt: fileName.split(".")[0],
              url:"https://goldbox-static.oss-cn-shanghai.aliyuncs.com/qr-code/" +fileName+'?'+this.time
            });
          }
          this.tableData = items;
        })
        .catch(err => {
          if (err.response.status == 401) {
            Message.error("登录过期");
            this.$router.replace({ path: "/login" });
          } else {
            Message.error(JSON.stringify(err));
          }
        });
    },
    readyPrint(item) {
      console.log(item)
      this.item = JSON.parse(JSON.stringify(item));
      this.dialogVisible = true;
    },
    closeDialog(){
      this.dialogVisible = false
      this.item = {}
    },
    printAll() {
      if (this.tableData && this.tableData.length) {
        this.printList = JSON.parse(JSON.stringify(this.tableData));
        this.dialogVisible = true;
      }
    },
    // toPrint() {
    //     this.dialogVisible = false;
    //     if (this.printList.length > 1) {
    //         for (let i = 0; i < this.tableData.length; i++) {
    //             this.tableData[i].status = 1;
    //         }
    //     } else {
    //         for (let i = 0; i < this.tableData.length; i++) {
    //             if (this.printList[0] && this.printList[0].status)
    //                 this.tableData[i].status = 1;
    //         }
    //     }
    // },
    afresh(data) {
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        let md5Str = md5(data[i].split(".")[0]);
        arr.push({ SerialNum: md5Str, PasswordHash: sha256(md5Str) });
      }
      if (arr.length) {
        postMd5(arr)
          .then(() => {})
          .catch(err => {
            console.log(err);
          });
      }
    }
  }
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}

.title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin: 0;
  padding: 24px 0;
}

.el-table {
  width: 60%;
  margin: 0 auto;
}

.actions {
  width: 60%;
  margin: 0 auto 20px;
  text-align: right;
}

.actions .btn {
  margin-right: 100px;
}

.qrcode-item {
  page-break-before: always;
  padding-top: 30px;
}

.scroll {
  max-height: 300px;
  overflow: auto;
}
</style>